import { createRef } from "react";
import {
  dataStatus,
  fileTags,
  actions,
  revisionFromList,
  processDefaultTableSortFile,
  getRequestDateMoment,
  savedInRadioValues,
} from "../../publicDictionaryValues";
import reasonEditDefaultIcon from "../../../assets/image/reasonEditIcon.png";
import ProcessBase from "../../commonComponents/processBase/index";
import ProcedureDetailService from "../../../service/procedureFile/ProcedureDetailService";
import CompleteStepBusinessType from "../../../service/stepBase/completeStepBusinessType";
import StepService from "../../../service/stepBase/StepService";
import { disableInteraction, enableInteraction } from "utils";
import StepBusinessType from "service/stepBase/stepBusinessType";

const procedureReplaceFileRef = createRef();

export default class ProcedureFileProcess extends ProcessBase {
  constructor(props: any) {
    super(props);
    this.setGlobalVariables();
    this.initProcedureFileRevisionInfoState();
    this.initProcedureFileState();
    // @ts-ignore
    this.serverPathReturnReasonLog = [];
    // @ts-ignore
    this.initProcedureTableData = [];
    // @ts-ignore
    this.savedInReturnReasonLog = [];
    // @ts-ignore
    this.procedureFileStepID = null;
    // @ts-ignore
    this.categoryID = null;
    // @ts-ignore
    this.accountID = null;
    // @ts-ignore
    this.taskGroupID = null;
    // @ts-ignore
    this.taskLabelID = null;
    // @ts-ignore
    this.clientServerJB = null;
    // @ts-ignore
    this.procedureStatusJB = null;
    // @ts-ignore
    this.isLevelCChange = false;
    // @ts-ignore
    this.isApprovePendingPage = undefined;
    // @ts-ignore
    this.isApproveCompletePage = undefined;
    // @ts-ignore
    this.isRevisePendingPage = undefined;
    // @ts-ignore
    this.isReviseCompletePage = undefined;
    // @ts-ignore
    this.isSubmitCompletePage = undefined;
  }

  initProcedureFileRevisionInfoState = () => {
    // @ts-ignore
    this.initRevisionInfoState = {
      revisionFormID: null,
      revisionDescription: null,
      revisionCategory: null,
      requestDate: null,
      requestFrom: null,
      requestFromDesc: null,
      attachmentIds: [],
      attachmentNames: [],
      attachmentFiles: [],
    };
  };

  /**
   * Init Component State
   */
  initProcedureFileState = () => {
    this.state = {
      pageState: {
        flowCategoryID: null,
        requestByID: null,
        requestByName: null,
        receiveDate: null,
        procedureID: null,
        procedureStepID: null,
        procedureAccountID: null,
        procedureStatus: null,
        isSaveDisabled: false,
        isCancelDisabled: false,
        isSubmitDisabled: false,
        isRejectDisabled: false,
        procedureFolder: {},
        rejectReason: null,
        rejectStatus: null,
        currentRole: null,
        actionName: null,
        loading: false,
        procedureStepStatus: null,
        uploadProcedureFileNum: 0,
        procedureFileNum: 0,
        procedureNote: "",
      },
      initTableDate: {},
      // @ts-ignore
      savedInSectionState: this.initSavedInSectionState,
      // @ts-ignore
      serverPathSectionState: this.initServerPathSectionState,
      // @ts-ignore
      procedureFileTableState: this.initProcedureFileTableState,
      // @ts-ignore
      revisionInfoState: this.initRevisionInfoState,
      supportingTableData: [],
      isReturnReasonLogOpen: false,
      fileTableData: [],
      taskInfoData: {},
      procedureInfoData: {},
      procedureFileData: {},
      shareTaskData: {},
      ppoList: [],
      fileLoading: { currentNum: 0, allNum: 0 },
    };
  };

  _showLoading = () => {
    disableInteraction();
    this.setState({
      pageState: {
        ...this.state.pageState,
        loading: true,
      },
    });
  };

  _hideLoading = async () => {
    await enableInteraction();
    this.setState({
      pageState: {
        ...this.state.pageState,
        loading: false,
      },
    });
  };

  setProcedureFileSavedInSectionState = (result: any) => {
    // check all history saved in ids and current saved in id to determine is change or not
    const allHistorySavedInIds = (result.procedureFolder?.stepHistoryList ?? []).map(
      (i: any) => i.procedureSaveInCategoryID
    );
    const isChanged =
      new Set([...allHistorySavedInIds, result.procedureFolder?.procedureSaveInCategoryID]).size >
        1 || Boolean(result.procedureFolder?.isChangeProcedureSavedIn);
    return {
      ...this.state.savedInSectionState,
      procedureSaveInCategoryStatusID:
        result.procedureFolder?.procedureSaveInCategoryStatusID || null,
      isSavedInApproveBtnDisabled:
        result.procedureFolder?.procedureSaveInCategoryStatusID === dataStatus.approval,
      isSavedInReturned:
        result.procedureFolder?.procedureSaveInCategoryStatusID === dataStatus.return,
      isSavedInReturnBtnDisabled:
        result.procedureFolder?.procedureSaveInCategoryStatusID === dataStatus.return,
      savedInReturnReasonInputValue:
        result.procedureFolder?.procedureSaveInCategoryReturnReason || null,
      savedInRadioValue: result.procedureFolder?.procedureSaveInCategoryID || null,
      isSavedInSectionChange: isChanged ? "" : "SavedInNoChange",
    };
  };

  setProcedureFileServerPathSectionState = (result: any) => {
    // check all history server path and current server path to determine is change or not
    const allHistoryPaths = (result.procedureFolder?.stepHistoryList ?? []).map(
      (i: any) => i.clientServerPath
    );
    const isChanged =
      new Set([...allHistoryPaths, result.procedureFolder?.clientServerPath]).size > 1 ||
      Boolean(result.procedureFolder?.isChangeClientServerPath);
    return {
      ...this.state.serverPathSectionState,
      serverPathValue: result.procedureFolder?.clientServerPath || null,
      serverPathReturnReasonInputValue:
        result.procedureFolder?.clientServerPathReturnReason || null,
      clientServerPathStatusName: result.procedureFolder?.clientServerPathStatusName || null,
      clientServerPath: result.procedureFolder?.clientServerPath || "",
      clientServerPathStatusID: result.procedureFolder?.clientServerPathStatusID || null,
      isServerPathApproveBtnDisabled:
        result.procedureFolder?.clientServerPathStatusID === dataStatus.approval,
      isServerPathReturnBtnDisabled:
        result.procedureFolder?.clientServerPathStatusID === dataStatus.return,
      isServerPathReturned: result.procedureFolder?.clientServerPathStatusID === dataStatus.return,
      isServerPathSectionChange: isChanged ? "" : "ServerPathNoChange",
    };
  };

  setSavedInServerPathState = (result: any) => {
    this.setState({
      savedInSectionState: this.setProcedureFileSavedInSectionState(result),
      serverPathSectionState: this.setProcedureFileServerPathSectionState(result),
    });
  };

  /* function about adjust data when get data from api */
  handleProcedureFileDataNull = (file: any, key: any) => {
    if (file[key] === null) {
      if (key === "procedureFileID") {
        return 0;
      } else {
        return null;
      }
    } else {
      return file[key];
    }
  };

  /* get proceudre file return reason log */
  getProcedureFileReturnReasonLog = (folder: any, key: any) => {
    const returnReasonLog: any[] = [];
    let historyList = folder.stepHistoryList;
    historyList.sort((a: any, b: any) => {
      return b.modifiedDate.localeCompare(a.modifiedDate);
    });
    historyList.forEach((stepItem: any, index: any) => {
      stepItem.actionID === actions.return &&
        stepItem.procedureFiles.forEach((fileItem: any, index: any) => {
          if (
            fileItem.fileKey === key &&
            fileItem.dataStatusID === dataStatus.return &&
            fileItem.returnReason !== null
          ) {
            returnReasonLog.push({
              key: index,
              returnedBy: stepItem.auditedByName,
              returnDate: this._formateDate(stepItem.modifiedDate),
              returnReasonColumn: fileItem.returnReason,
            });
          }
        });
    });
    return returnReasonLog;
  };

  /* function set approve and return button disabled when init load page */
  // @ts-ignore
  handleReturnInitBtnDisabled = (procedureFile: any, status: any) =>
    this.isRevisePage
      ? false
      : this.handleProcedureFileDataNull(procedureFile, "dataStatusID") === status;

  /* function about sort approve apge and revise page procedure file list */
  handleSortFile = (result: any) => {
    return processDefaultTableSortFile(result.procedureFolder?.procedureFiles, this._formateDate);
  };

  /* function about prepare file table data to show */
  setProcedureTableData = (result: any) => {
    if (result.procedureFolder === null) {
      return;
    }
    const procedureFileList = this.handleSortFile(result);
    let isRevise = false;
    if (
      result.workflowProcessStepInfo !== null &&
      result.workflowProcessStepInfo.annotations.length !== 0
    ) {
      isRevise =
        result.workflowProcessStepInfo.annotations.find((item: any) => item.name === "IsRevise")
          .value === "1";
    }
    procedureFileList.forEach((procedureFile) => {
      const isReviseOrNoOldFile =
        this.handleProcedureFileDataNull(procedureFile, "oldFileID") === null || !isRevise;
      const isDeleteOrNoOldFile =
        this.handleProcedureFileDataNull(procedureFile, "oldFileID") === null ||
        this.handleProcedureFileDataNull(procedureFile, "fileTagID") === fileTags.deleted;
      if (!procedureFile.isDelete) {
        const lineId = this._generateGUID();
        const uploadedDate = this.handleProcedureFileDataNull(procedureFile, "uploadedDate");
        const approvedDate = this.handleProcedureFileDataNull(procedureFile, "approvedDate");
        // @ts-ignore
        this.procedureTableData.push({
          data: [
            { name: "lineId", value: lineId },
            {
              name: "fileId",
              value: isReviseOrNoOldFile
                ? this.handleProcedureFileDataNull(procedureFile, "fileID")
                : this.handleProcedureFileDataNull(procedureFile, "oldFileID"),
            },
            {
              name: "procedureFileID",
              value: this.handleProcedureFileDataNull(procedureFile, "procedureFileID"),
            },
            {
              name: "procedureFileStepID",
              value: this.handleProcedureFileDataNull(procedureFile, "procedureFileStepID"),
            },
            {
              name: "fileKey",
              value: this.handleProcedureFileDataNull(procedureFile, "fileKey"),
            },
            {
              name: "fileName",
              value: isReviseOrNoOldFile
                ? this.handleProcedureFileDataNull(procedureFile, "fileName")
                : this.handleProcedureFileDataNull(procedureFile, "oldFileName"),
              tagValue: this.handleProcedureFileDataNull(procedureFile, "fileTagID"),
            },
            {
              name: "uploadedDate",
              value: this._formateDate(uploadedDate),
            },
            {
              name: "uploadByName",
              value: this.handleProcedureFileDataNull(procedureFile, "uploadByName"),
            },
            {
              name: "uploadById",
              value: this.handleProcedureFileDataNull(procedureFile, "uploadBy"),
            },
            {
              name: "note",
              value: this.handleProcedureFileDataNull(procedureFile, "note"),
              isDisabled: false,
            },
            {
              name: "proposedChange",
              value: this.handleProcedureFileDataNull(procedureFile, "proposedChangeTagID"),
            },
            {
              name: "status",
              value: this.handleProcedureFileDataNull(procedureFile, "dataStatusID"),
            },
            {
              name: "returnReason",
              value: this.handleProcedureFileDataNull(procedureFile, "returnReason"),
              isDisabled: this.handleProcedureFileDataNull(procedureFile, "returnReason") === null,
              isShowReasonLog:
                this.getProcedureFileReturnReasonLog(result.procedureFolder, procedureFile.fileKey)
                  .length > 0,
              reasonLog: this.getProcedureFileReturnReasonLog(
                result.procedureFolder,
                procedureFile.fileKey
              ),
            },
            {
              name: "attachment",
              value: this.handleProcedureFileDataNull(procedureFile, "attachmentName"),
              fileId: this.handleProcedureFileDataNull(procedureFile, "attachmentFileID"),
              link: "#JavaScript:;",
              isDisabled: false,
            },
            {
              name: "newVersion",
              value: isDeleteOrNoOldFile
                ? null
                : this.handleProcedureFileDataNull(procedureFile, "fileName"),
              fileId: isDeleteOrNoOldFile
                ? null
                : this.handleProcedureFileDataNull(procedureFile, "fileID"),
              link: "#JavaScript:;",
            },
            {
              name: "previousStatus",
              value: this.handleProcedureFileDataNull(procedureFile, "dataStatusID"),
            },
            {
              name: "previousFileTag",
              value: this.handleProcedureFileDataNull(procedureFile, "fileTagID"),
            },
            {
              name: "isReviewed",
              value: this.handleProcedureFileDataNull(procedureFile, "isReviewed"),
            },
            {
              name: "approveDate",
              value: this._formateDate(approvedDate),
            },
            {
              name: "jbProcedure",
              value: this.handleProcedureFileDataNull(procedureFile, "jbProcedure"),
            },
          ],
          checked: false,
          isApproveDisabled: this.handleReturnInitBtnDisabled(procedureFile, dataStatus.approval),
          isReturnDisabled: this.handleReturnInitBtnDisabled(procedureFile, dataStatus.return),
          isReturned: this.handleReturnInitBtnDisabled(procedureFile, dataStatus.return),
          isError: false,
          replaceRef: procedureReplaceFileRef,
          attachmentEditIcon: reasonEditDefaultIcon,
          isDelete: false,
          isUpdate: false,
        });
      }
    });
  };

  setProcedureFileSavedInReturnReasonLog = (item: any, index: any) => {
    if (
      item.procedureSaveInCategoryStatusID === dataStatus.return &&
      item.actionID === actions.return
    ) {
      // @ts-ignore
      this.savedInReturnReasonLog.push({
        key: index,
        returnedBy: item.auditedByName,
        returnDate: this._formateDate(item.modifiedDate),
        returnReasonColumn: item.procedureSaveInCategoryReturnReason,
      });
    }
  };

  setProcedureFileServerPathReturnReasonLog = (item: any, index: any) => {
    if (
      item.clientServerPathStatusID === dataStatus.return &&
      item.actionID === actions.return &&
      (item.procedureSaveInCategoryID === savedInRadioValues.systemAndClientServer ||
        item.procedureSaveInCategoryID === savedInRadioValues.serverOnly)
    ) {
      // @ts-ignore
      this.serverPathReturnReasonLog.push({
        key: index,
        returnedBy: item.auditedByName,
        returnDate: this._formateDate(item.modifiedDate),
        returnReasonColumn: item.clientServerPathReturnReason,
      });
    }
  };

  setProcedureFileSavedInAndServerPathReturnReasonLog = (list: any) => {
    list.sort((a: any, b: any) => {
      return b.modifiedDate.localeCompare(a.modifiedDate);
    });
    list.forEach((item: any, index: any) => {
      this.setProcedureFileSavedInReturnReasonLog(item, index);
      this.setProcedureFileServerPathReturnReasonLog(item, index);
    });
  };

  /**
   * set supporting file section data
   * @param {*} result
   */
  setSupportingFileData = (result: any) => {
    if (result.supportingFolder !== null) {
      this.setSupportingTableData(result);
      this.setState({
        // @ts-ignore
        supportingTableData: this.supportingTableData,
      });
    }
  };

  setRevisionInfo = (data: any) => {
    const fileIds: any[] = [];
    const fileNames: any[] = [];
    const fileList: any[] = [];
    data.attachmentFiles !== null &&
      data.attachmentFiles.forEach((item: any) => {
        fileIds.push(item.fileId);
        fileNames.push(item.fileName);
        fileList.push({ fileId: item.fileId, fileName: item.fileName });
      });
    this.setState({
      revisionInfoState: {
        ...this.state.revisionInfoState,
        revisionFormID: data.revisionFormID,
        revisionDescription: data.revisionDescription,
        revisionCategory: data.revisionCategoryID,
        requestDate: data.requestDate,
        requestFrom: data.requestFromID,
        requestFromDesc: data.requestFromDesc,
        attachmentIds: [...fileIds],
        attachmentNames: [...fileNames],
        attachmentFiles: [...fileList],
      },
    });
  };

  /**
   * function about set revision information data from api
   * @param {obj} data
   * @returns
   */
  buildRevisionInfoState = (data: any) => {
    const fileIds: any[] = [];
    const fileNames: any[] = [];
    const fileList: any[] = [];
    data.attachmentFiles !== null &&
      data.attachmentFiles.forEach((item: any) => {
        fileIds.push(item.fileId);
        fileNames.push(item.fileName);
        fileList.push({ fileId: item.fileId, fileName: item.fileName });
      });

    return {
      ...this.state.revisionInfoState,
      revisionFormID: data.revisionFormID,
      revisionDescription: data.revisionDescription,
      revisionCategory: data.revisionCategoryID,
      requestDate: data.requestDate,
      requestFrom: data.requestFromID,
      requestFromDesc: data.requestFromDesc,
      attachmentIds: [...fileIds],
      attachmentNames: [...fileNames],
      attachmentFiles: [...fileList],
    };
  };

  setProcedureFileData = (result: any) => {
    if (result.procedureFolder !== null) {
      const historyList = result.procedureFolder?.stepHistoryList.sort((x: any, y: any) =>
        y.modifiedDate.localeCompare(x.modifiedDate)
      );

      // @ts-ignore
      this.initServerPathSectionState = {
        // @ts-ignore
        ...this.initServerPathSectionState,
        ...this.buildProcedureFileServerPathSectionState(result.procedureFolder),
      };

      // @ts-ignore
      this.initSavedInSectionState = {
        // @ts-ignore
        ...this.initSavedInSectionState,
        ...this.buildProcedureFileSavedInSectionState(result.procedureFolder),
      };

      // @ts-ignore
      this.initRevisionInfoState = {
        // @ts-ignore
        ...this.initRevisionInfoState,
        ...(result.procedureFolder.revisionFormInfo
          ? this.buildRevisionInfoState(result.procedureFolder.revisionFormInfo)
          : {}),
      };

      if (historyList.length !== 0) {
        const lastStepHistoryData = historyList[0];
        // @ts-ignore
        this.primitiveServerPathSectionState = {
          // @ts-ignore
          ...this.primitiveServerPathSectionState,
          ...this.buildProcedureFileServerPathSectionState(lastStepHistoryData),
        };
        // @ts-ignore
        this.primitiveSavedInSectionState = {
          // @ts-ignore
          ...this.primitiveSavedInSectionState,
          ...this.buildProcedureFileSavedInSectionState(lastStepHistoryData),
        };
      }

      // @ts-ignore
      this.procedureFileStepID = result.procedureFolder?.procedureFileStepID;
      // @ts-ignore
      this.isLevelCChange = result.procedureFolder?.isChangeLevelC;
      // @ts-ignore
      this.categoryID = result.taskInfomation.categoryID;
      // @ts-ignore
      this.accountID = result.taskInfomation.accountID;
      // @ts-ignore
      this.taskGroupID = result.taskInfomation.taskGroupID;
      // @ts-ignore
      this.taskLabelID = result.taskInfomation.taskLabelID;
      // @ts-ignore
      this.clientServerJB = result.procedureFolder?.jbProcedureSaveIn;
      // @ts-ignore
      this.procedureStatusJB = result.procedureFolder?.procedureJBStatusID;
      this.setProcedureTableData(result);
      // @ts-ignore
      this.procedureTableData.forEach((item: any) => {
        // @ts-ignore
        this.initProcedureTableData.push({
          data: JSON.parse(JSON.stringify(item.data)),
          checked: item.checked,
          isApproveDisabled: item.isApproveDisabled,
          isReturnDisabled: item.isReturnDisabled,
          isReturned: item.isReturned,
          isError: item.isError,
          replaceRef: item.replaceRef,
          attachmentEditIcon: reasonEditDefaultIcon,
          isDelete: false,
          isUpdate: false,
        });
      });

      if (result.procedureFolder?.revisionFormInfo) {
        this.setRevisionInfo(result.procedureFolder.revisionFormInfo);
      }

      this.setState({
        // @ts-ignore
        fileTableData: this.procedureTableData,
      });
      this.setProcedureFileSavedInAndServerPathReturnReasonLog(
        result.procedureFolder?.stepHistoryList
      );
      this.setSavedInServerPathState(result);
    }
  };

  /**
   * Build SaveIn Section Data From ProcedureFolder
   * @param {*} data
   * @param {*} isRevise
   * @returns
   */
  buildProcedureFileSavedInSectionState = (data: any) => {
    return {
      savedInReturnReasonInputValue: data.procedureSaveInCategoryReturnReason,
      savedInRadioValue: data.procedureSaveInCategoryID,
      isSavedInReturned: data.procedureSaveInCategoryStatusID === dataStatus.return,
      procedureSaveInCategoryStatusID: data.procedureSaveInCategoryStatusID,
      isSavedInApproveBtnDisabled: data.procedureSaveInCategoryStatusID === dataStatus.approval,
      isSavedInReturnBtnDisabled: data.procedureSaveInCategoryStatusID === dataStatus.return,
    };
  };

  /**
   * Build ServerPath Section Data From ProcedureFolder
   * @param {*} data
   * @param {*} isRevise
   * @returns
   */
  buildProcedureFileServerPathSectionState = (data: any) => {
    return {
      // @ts-ignore
      ...this.primitiveServerPathSectionState,
      serverPathValue: data.clientServerPath,
      isServerPathReturned: data.clientServerPathStatusID === dataStatus.return,
      serverPathReturnReasonInputValue: data.clientServerPathReturnReason,
      clientServerPathStatusID: data.clientServerPathStatusID,
      clientServerPathStatusName: data.clientServerPathStatusName,
      clientServerPath: data.clientServerPath,
      isServerPathApproveBtnDisabled: data.clientServerPathStatusID === dataStatus.approval,
      isServerPathReturnBtnDisabled: data.clientServerPathStatusID === dataStatus.return,
    };
  };

  _getFlowDataSuccess = (result: any) => {
    const { procedureStepStatus } = result;

    StepService.setStepInterfaceMergePayload(result, {
      isHistorical: procedureStepStatus === "Complete",
      isShareTaskProcess: false,
      // @ts-ignore
      procedureStepId: this.procedureStepID,
      // @ts-ignore
      procedureTaskId: this.taskID,
    });

    this.getInitData(
      ProcedureDetailService.getProcedureFolderStepItem,
      "Get Procedure Files Failed",
      procedureStepStatus === "Complete"
        ? [
            {
              dataKey: "procedureFolder",
              settingKey: "getProcedureFileStepItemCompleted",
            },
            StepBusinessType.taskInfo,
          ]
        : undefined,
      result,
      StepService.getMergePayloadBySettingKey([CompleteStepBusinessType.taskInfo.settingKey])
    );
  };

  _getFlowDataFailed = () => {
    this._alertError("Get Procedure Files Failed");
  };

  getFlowData = () => {
    const parentPageData = this._getRoutingParam("ParentPage");
    const param = {
      // @ts-ignore
      taskID: this.taskID,
      // @ts-ignore
      procedureID: this.procedureID,
      // @ts-ignore
      procedureStepID: this.procedureStepID,
      parentPage: parentPageData,
    };
    ProcedureDetailService.getFlowStepData(
      param,
      this._getFlowDataSuccess,
      this._getFlowDataFailed
    );
  };

  componentDidMount() {
    this.getFlowData();
  }

  /* function about get data from procedure file table */
  returnProcedureFileDataValue = (name: any, index: any, ref: any) => {
    const procedureFileData = ref.current.getDataList();
    let deleteList = ref.current.getDeleteList();
    let combineDatalist = procedureFileData.concat(deleteList);
    return combineDatalist[index].data.find((item: any) => item.name === name);
  };

  /* function about return submit data to use in integrate trigger api */
  handleReturnSubmitData = ({
    actionID,
    actionName,
    procedureSavedInRef,
    procedureServerPathRef,
    pageProcedureRef,
    approvePageRef,
    revisionInfoRef,
    isLevelCChangeValue,
    levelCRef,
  }: any) => {
    const fileDtos: any[] = [];
    const isChangeLevelC =
      isLevelCChangeValue || (levelCRef ? levelCRef.current.state.isLevelCChange : false);

    if (pageProcedureRef.current !== null) {
      const procedureFileData = pageProcedureRef.current.getDataList();
      let deleteList = pageProcedureRef.current.getDeleteList();
      let combineDatalist = procedureFileData.concat(deleteList);
      combineDatalist.forEach((item: any, index: any) => {
        const replaceUserId = this.returnProcedureFileDataValue(
          "replaceUserId",
          index,
          pageProcedureRef
        )?.value;
        const replaceUserName = this.returnProcedureFileDataValue(
          "replaceUserName",
          index,
          pageProcedureRef
        )?.value;
        fileDtos.push({
          fileID:
            this.returnProcedureFileDataValue("newVersion", index, pageProcedureRef).fileId === null
              ? this.returnProcedureFileDataValue("fileId", index, pageProcedureRef).value
              : this.returnProcedureFileDataValue("newVersion", index, pageProcedureRef).fileId,
          createdDate: this.returnProcedureFileDataValue("uploadedDate", index, pageProcedureRef)
            .value,
          uploadBy:
            replaceUserId && replaceUserName
              ? replaceUserId
              : this.returnProcedureFileDataValue("uploadById", index, pageProcedureRef).value,
          uploadByName:
            replaceUserId && replaceUserName
              ? replaceUserName
              : this.returnProcedureFileDataValue("uploadByName", index, pageProcedureRef).value,
          fileName:
            this.returnProcedureFileDataValue("newVersion", index, pageProcedureRef).value === null
              ? this.returnProcedureFileDataValue("fileName", index, pageProcedureRef).value
              : this.returnProcedureFileDataValue("newVersion", index, pageProcedureRef).value,
          fileKey: this.returnProcedureFileDataValue("fileKey", index, pageProcedureRef).value,
          dataStatusID: this.returnProcedureFileDataValue("status", index, pageProcedureRef).value,
          attachmentFileID: this.returnProcedureFileDataValue("attachment", index, pageProcedureRef)
            .fileId,
          attachmentName: this.returnProcedureFileDataValue("attachment", index, pageProcedureRef)
            .value,
          returnReason: this.returnProcedureFileDataValue("returnReason", index, pageProcedureRef)
            .value,
          fileTagID: this.returnProcedureFileDataValue("fileName", index, pageProcedureRef)
            .tagValue,
          // @ts-ignore
          procedureFileStepID: this.procedureFileStepID,
          procedureFileID: this.returnProcedureFileDataValue(
            "procedureFileID",
            index,
            pageProcedureRef
          ).value,
          note: this.returnProcedureFileDataValue("note", index, pageProcedureRef)?.value,
          proposedChangeTagID: this.returnProcedureFileDataValue(
            "proposedChange",
            index,
            pageProcedureRef
          )?.value,
          oldFileID:
            this.returnProcedureFileDataValue("newVersion", index, pageProcedureRef).fileId === null
              ? null
              : this.returnProcedureFileDataValue("fileId", index, pageProcedureRef).value,
          oldFileName:
            this.returnProcedureFileDataValue("newVersion", index, pageProcedureRef).value === null
              ? null
              : this.returnProcedureFileDataValue("fileName", index, pageProcedureRef).value,
          isReviewed:
            this.returnProcedureFileDataValue("isReviewed", index, pageProcedureRef).value ===
            undefined
              ? null
              : this.returnProcedureFileDataValue("isReviewed", index, pageProcedureRef).value,
          isDelete: item.isDelete,
          isUpdate: item.isUpdate,
        });
      });
    }

    const { savedInRadioValue, procedureSaveInCategoryStatusID, savedInReturnReasonInputValue } =
      procedureSavedInRef.current.state.savedInSectionState;

    let serverPathValue = null;
    let serverPathStatus = null;
    let serverPathReturnReasonInputValue = null;
    if (
      procedureServerPathRef.current !== null &&
      !(
        (actionID === actions.submit || actionID === actions.revise) &&
        savedInRadioValue !== savedInRadioValues.systemAndClientServer &&
        savedInRadioValue !== savedInRadioValues.serverOnly
      )
    ) {
      const serverPathState = procedureServerPathRef.current.state.serverPathSectionState;
      serverPathValue = serverPathState.serverPathValue;
      serverPathStatus = serverPathState.serverPathStatus;
      serverPathReturnReasonInputValue = serverPathState.serverPathReturnReasonInputValue;
    }

    let currentCategory = null;
    let currentRequestDate = null;
    let currentRequestFrom = null;
    let currentDesciption = null;
    let currentAttachment = [];
    let currentClientValue = null;
    let currentRspValue: any = null;
    let rspValueName = null;
    let isRequestDateChange = false;

    if (revisionInfoRef !== undefined && revisionInfoRef.current !== null) {
      currentCategory = revisionInfoRef.current.state.currentCategory;
      currentRequestDate = revisionInfoRef.current.state.currentRequestDate;
      currentRequestFrom = revisionInfoRef.current.state.currentRequestFrom;
      currentDesciption = revisionInfoRef.current.state.currentDesciption;
      currentAttachment = revisionInfoRef.current.state.currentAttachment;
      currentClientValue = revisionInfoRef.current.state.currentClientValue;
      currentRspValue = revisionInfoRef.current.state.currentRspValue;
      isRequestDateChange = revisionInfoRef.current.state.isRequestDateChange;
      const clientMemberList = revisionInfoRef.current.state.clientMemberList;
      rspValueName =
        clientMemberList.find((item: any) => item.value === currentRspValue)?.name ??
        currentRspValue;
    }

    return {
      // @ts-ignore
      procedureId: this.procedureId,
      // @ts-ignore
      workflowProcessInstanceId: this.workflowProcessInstanceId,
      // @ts-ignore
      flowCategoryID: this.flowCategoryID,
      actionName: actionName,
      actionID: actionID,
      accountID: null,
      rejectReason:
        approvePageRef === undefined || approvePageRef.current === null
          ? null
          : approvePageRef.current.state.pageState.rejectReason,
      // @ts-ignore
      procedureStepID: this.procedureStepID,
      clientServerPath: serverPathValue,
      clientServerPathStatusID: serverPathStatus,
      clientServerPathReturnReason: serverPathReturnReasonInputValue,
      procedureSaveInCategoryID: savedInRadioValue,
      procedureSaveInCategoryStatusID: procedureSaveInCategoryStatusID,
      procedureSaveInCategoryReturnReason: savedInReturnReasonInputValue,
      // @ts-ignore
      isInitial: this.isRevisePage,
      procedureFiles: fileDtos,
      revisionForm: {
        revisionFormID: this.state.revisionInfoState.revisionFormID,
        revisionDescription: currentDesciption,
        revisionCategoryID: currentCategory,
        requestDate: getRequestDateMoment(currentRequestDate, isRequestDateChange),
        requestFromID: currentRequestFrom,
        requestFromDesc:
          currentRequestFrom === revisionFromList.Client ? currentClientValue : rspValueName,
        attachmentFiles: [...currentAttachment],
      },
      // @ts-ignore
      procedureFileStepID: this.procedureFileStepID,
      isChangeLevelC: isChangeLevelC,
    };
  };
}
